import React from "react";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EmptyState({ icon: Icon = Inbox, title, description, actionLabel, onAction, testId }) {
  return (
    <div
      data-testid={testId || "empty-state"}
      className="flex flex-col items-center justify-center text-center py-16 px-6"
    >
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mb-4">
        <Icon className="text-slate-400" size={28} />
      </div>
      <h3 className="text-lg font-bold text-slate-900">{title}</h3>
      {description && <p className="text-slate-500 mt-1 max-w-sm">{description}</p>}
      {actionLabel && (
        <Button data-testid="empty-state-action" onClick={onAction} className="mt-5 bg-blue-600 hover:bg-blue-700 rounded-lg">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}

export function Loading({ label = "Sedang memuat..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-slate-500" data-testid="loading-state">
      <div className="w-8 h-8 border-3 border-slate-200 border-t-blue-600 rounded-full animate-spin mb-3" />
      <p>{label}</p>
    </div>
  );
}
